<val-boite-dialogue-generique #boiteDialogue
                              [titre]="titre | transloco"
                              class="val-activer-desactiver-factures-achat"
                              [validerDesactive]="actionSelectionnee === null"
                              (validerClick)="Valider ()"
                              (annulerClick)="Annuler ()">
  <div contenu class="val-activer-desactiver-factures-achat-contenu">
    <val-simple-panel>
      <val-controle-conteneur [label]="'achat.commun.action' | transloco"
                              [tailleLabel]="tailleLabels">
        <kendo-combobox class="val-kd-combobox"
                        size="small"
                        [clearButton]="false"
                        [popupSettings]="{appendTo: 'component', popupClass: 'val-kd-combo-popup'}"
                        [data]="actions"
                        textField="libelle"
                        valueField="desactiver"
                        [(value)]="actionSelectionnee">
        </kendo-combobox>
      </val-controle-conteneur>
      <div style="height: 4px;"></div>
      <div class="val-activer-desactiver-factures-achat-selection">
        {{ 'achat.commun.factures-selectionnees' | transloco: { nombre: nombreFacturesSelectionnees } }}
      </div>
    </val-simple-panel>
  </div>
</val-boite-dialogue-generique>
<val-boite-dialogue-messages #boiteDialogueMessages></val-boite-dialogue-messages>
